import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {
  private storage = sessionStorage;

  setPageIndex(key: string, pageIndex: number): void {
    this.storage.setItem(`pagination_${key}`, pageIndex.toString());
  }

  getPageIndex(key: string): number {
    const value = this.storage.getItem(`pagination_${key}`);
    return value ? +value : 0;
  }

  clearPageIndex(key: string): void {
    this.storage.removeItem(`pagination_${key}`);
  }
}
